export default "__VITE_ASSET__CT5SU10p__"